export function validateKoreanRRN(input: string) {
  // 정규식 패턴을 사용하여 주민등록번호 유효성 검사
  const rrnPattern =
    /^(?:\d{6}|\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12][0-9]|3[01]))-?\d{7}$/;

  return rrnPattern.test(input);
}
